import React from "react";

const ForgotPassword = () => {
  return <div className="page-content">Forgot Password</div>;
};

export default ForgotPassword;
